import { render } from "./SlotInfo.vue?vue&type=template&id=7bdd966c&scoped=true"
import script from "./SlotInfo.vue?vue&type=script&lang=js"
export * from "./SlotInfo.vue?vue&type=script&lang=js"

import "./SlotInfo.vue?vue&type=style&index=0&id=7bdd966c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7bdd966c"]])

export default __exports__